import React from 'react';
import { styled } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { Box, Divider, useMediaQuery, IconButton, SvgIcon, Typography, useTheme } from '@mui/material';
import { Menu as MenuIcon } from 'react-feather';
// import { openSidebar } from 'src/actions/chatActions';
import MessageAdd from '../MessageAdd';
import Search from './Search';

const PREFIX = 'ThreadNew';

const classes = {
  root: `${PREFIX}-root`,
  search: `${PREFIX}-search`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
  },

  [`& .${classes.search}`]: {
    marginLeft: theme.spacing(2),
  },
}));

function ThreadNew() {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  // const dispatch = useDispatch();

  // const handleOpenSidebar = () => {
  //   dispatch(openSidebar());
  // };

  return (
    <Root className={classes.root}>
      {!isLargeScreen && (
        <>
          <Box px={2} py={1} bgcolor='white'>
            <IconButton
              className={classes.menuButton}
              // onClick={handleOpenSidebar}
              edge='start'
              size='large'
            >
              <SvgIcon fontSize='small'>
                <MenuIcon />
              </SvgIcon>
            </IconButton>
          </Box>
          <Divider />
        </>
      )}
      <div style={{ height: 68 }}></div>
      <Divider />
      {/* <Box
        display="flex"
        alignItems="center"
        p={2}
      >
        <Typography
          variant="body1"
          color="textSecondary"
        >
          To:
        </Typography>
        <Search className={classes.search} />
      </Box> */}
      <Box flexGrow={1} />
      <Divider />
      {/* <MessageAdd disabled /> */}
    </Root>
  );
}

export default ThreadNew;
